export enum SocketChannels {
  ConversationChannel = 'ConversationChannel',
  ChatUserChannel = 'ChatUserChannel',
  ChatWidgetChannel = 'ChatWidgetChannel',
  AllChatWidgetsChannel = 'AllChatWidgetsChannel',
  NotificationChannel = 'NotificationChannel',
  AnnouncementNotificationChannel = 'AnnouncementNotificationChannel',
  VisitPathChannel = 'VisitPathChannel',
  BotStatusChannel = 'BotStatusChannel',
  NonqliqConversationChannel = 'NonqliqConversationChannel',
  QliqChatConversationChannel = 'QliqChatConversationChannel',
  QliqChatUserChannel = 'SipUserChannel',
  SipUserChannel = 'SipUserChannel',
}
